import { Component, Input, SimpleChanges } from '@angular/core';
import { LoadingController} from 'ionic-angular';
import { Global } from '../../../global/global';


/**
 * Generated class for the LoaderComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'loader',
  templateUrl: 'loader.html'
})
export class LoaderComponent {
  @Input() isShowLoader: boolean;
  text: string;
  loader : any;

  constructor(    public loadingCtrl : LoadingController,private globalData : Global,) {
    console.log('Hello LoaderComponent Component');
    this.text = 'Hello World';
  }

  ngOnInit() {
   
    
  }

  ngOnChanges(changes: SimpleChanges ) {
    console.log("Position is", changes.position)
    if (changes.isShowLoader.currentValue == true && this.globalData.isLoaderShownHomepage) {
      if(this.loader == null){
        this.loader = this.loadingCtrl.create({
          content: "Please Wait",
        });
        this.loader.present();
        this.globalData.isLoaderShownHomepage = false;
      }
    }else if(changes.isShowLoader.currentValue == true && this.globalData.isLoaderShowninDetailPage){
      if(this.loader == null){
        this.loader = this.loadingCtrl.create({
          content: "Please Wait",
        });
        this.loader.present();
        this.globalData.isLoaderShowninDetailPage = false;
      }
    }
    else{
      try{
        if(this.loader != null){
          this.loader.dismiss();
           this.loader = null;
        }
      }catch(err){

      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/loader/loader.ts